module.exports = __webpack_public_path__ + "img/alert-danger.8d7cb290.svg";